import React, { useMemo, useRef } from 'react'

import { Favorite_PageIdEnum } from 'src/api/gen'
import { useURLAndStorageState } from 'src/commons/hooks/useURLAndStorageState'
import { IFilters } from 'src/commons/types'
import { useAgencySettings } from 'src/layout/AgencySettings'
import { useProviders } from 'src/layout/hooks'
import { useMapLayer } from 'src/layout/MapLayerWrapper'
import { FilteringCard } from 'src/muiv5/components/commons/Cards/FilteringCard'
import { getInitialFilters } from 'src/pages/Dashboard'

import PolicyComplianceCharts from '../Dashboard/PolicyComplianceCharts'

import { PolicyFilterPanel } from './PolicyFilterPanel'

export default function PolicyKPI() {
  const { activeProviders } = useProviders()
  const layers = useMapLayer()
  const { get_kpi_filter_range } = useAgencySettings()

  const defaultFilters = useMemo(() => getInitialFilters(layers, get_kpi_filter_range), [layers, get_kpi_filter_range])
  const [filters, setFilters] = useURLAndStorageState(Favorite_PageIdEnum.policies_kpi, defaultFilters)
  const displayedFiltersRef = useRef<IFilters>()

  const onApplyFilter = function () {
    if (!displayedFiltersRef.current) {
      throw new Error('There are no displayed filters')
    }

    setFilters(displayedFiltersRef.current)
  }

  return (
    <FilteringCard
      SideComponent={
        <PolicyFilterPanel
          ref={displayedFiltersRef}
          initialFilters={filters}
          defaultFilters={defaultFilters}
          providers={activeProviders}
        />
      }
      onApplyFilter={onApplyFilter}
    >
      <PolicyComplianceCharts filters={filters} />
    </FilteringCard>
  )
}
